<template>
  <div class="container-fluid col col-lg-10 offset-lg-1">
    <div class="card-deck" v-if="!isMobile()">
      <Card :poster="poster" v-for="(poster, index) in posters" v-bind:key="index"/>
    </div>
    <WallMobile :poster="poster" v-for="(poster, index) in posters" v-bind:key="index" v-else/>
  </div>
</template>

<script>
import Card from "../items/Card";
import WallMobile from "../items/WallMobile";

const VueScrollTo = require('vue-scrollto');

export default {
  components: {Card, WallMobile},
  data() {
    return {
      shareShow: null,
    }
  },
  props: ['posters'],
  name: "listCard",
  methods: {
    scrollTo: function () {
      let scrollspeed = 500;
      if (this.$browserDetect.meta.name === 'Chrome') {
        scrollspeed = 1500;
      }
      VueScrollTo.scrollTo('#poster' + this.$route.params.poster, scrollspeed, {easing: 'ease-in'});
    },
    setOpenCollapse: function (collapse) {
      this.$store.state.openCollapse = collapse;
    },
    getCollapseID(id) {
      while (id.includes(' ')) {
        id = id.replace(' ', '');
      }
      while (id.includes(':')) {
        id = id.replace(':', '');
      }
      return id;
    }
  },
  created() {
    if (!this.$store.state.ratings.length) {
      this.$store.dispatch('GET_ALL_RATINGS');
    }
  },
  mounted() {
    if (this.$store.state.openCollapse.length > 0) {
      $('#' + this.getCollapseID(this.$store.state.openCollapse)).collapse('show');
    }
    if (this.$route.params.poster > 0) {
      this.scrollTo();
    }
    this.$ga.event(process.env.VUE_APP_GOOGLE_ANALYTICS_NAME, 'view/' + this.$store.state.mode.displayType, 'grouped:' + this.$store.state.mode.grouped.status);
  }
}
</script>

<style scoped>
@media (min-width: 10em) {
  .card-deck > .card {
    width: 31%;
    flex-wrap: wrap;
    flex: initial;
  }
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
